import { render, staticRenderFns } from "./HotelGrid.vue?vue&type=template&id=6bde5fc1&scoped=true"
import script from "./HotelGrid.vue?vue&type=script&lang=js"
export * from "./HotelGrid.vue?vue&type=script&lang=js"
import style0 from "./HotelGrid.vue?vue&type=style&index=0&id=6bde5fc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde5fc1",
  null
  
)

export default component.exports